<template>
  <div>
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <a-card
            :bordered="false"
            class="header-solid h-full"
            :bodyStyle="{ padding: 0 }"
        >
          <template #title>
            <a-row type="flex" align="middle">
              <a-col :span="24" :md="12">
                <h5 class="font-semibold m-0">جدول کارمزد های سیستم</h5>
              </a-col>
              <a-col
                  :span="24"
                  :md="12"
                  style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                "
              >
                  <a-button class="btn-outline-primary"  target="_blank" :href="`${$store.state.baseUrl}/revenue-export`" >
                      <a-icon type="upload" />  خروجی اکسل
                  </a-button>
                <a-button
                    class="btn-outline-purple"
                    icon="search"
                    @click="isHidden = !isHidden"
                >
                  جستجو
                </a-button>

              </a-col>
            </a-row>
          </template>

          <b-card
              style="margin:20px; !important ; border:none;"
              v-if="isHidden"
          >
            <div class="row">
              <div class="col-md-6 ">
                <div class="form-group">
                  <label style="margin-bottom:10px;">از تاریخ  </label>
                  <date-picker v-model="search.start"></date-picker>

                </div>
              </div>
              <div class="col-md-6 ">
                <div class="form-group">
                  <label style="margin-bottom:10px;"> تا تاریخ </label>
                  <date-picker v-model="search.end"></date-picker>

                </div>
              </div>
            </div>

            <a-col style="margin-top: 20px" :md="4">

              <a-button
                  class="btn-outline-green w-100"
                  icon="search"
                  @click="getData"
              >
                جستجو
              </a-button>

            </a-col>
          </b-card>
          <a-row
              style="justify-content: center; display: flex"
              v-if="$store.state.loading"
          >
            <template>
              <div>
                <a-spin />
              </div>
            </template>
          </a-row>
          <div v-else>
            <section class="w-100 p-4 text-center">
              <div class="table-responsive">
                <table class="table table-hover ">
                  <thead>
                  <tr>
                    <th scope="col">شناسه</th>
                    <th scope="col">خریدار</th>
                    <th scope="col"> درصد کارمزد</th>
                    <th scope="col">مبلغ کارمزد </th>
                    <th scope="col">نام محصول</th>
                    <th scope="col"> فروشنده</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="row in data">
                    <th scope="row">#{{ row.id }}</th>
                    <td>

                      <b-badge variant="light" class="text-dark">{{
                          $root.full_name( row.user.firstname , row.user.lastname)
                        }}</b-badge>
                    </td>
                    <td>
                      <b-badge
                      
                          variant="light"
                          class="bg-secondary"
                      >{{row.wage_percent}}</b-badge
                      >
                    
                    </td>

                    <td>
                      <b-badge pill variant="info" class="bg-success"
                      >{{ $root.number_format(row.amount) }}
                      </b-badge>
                    </td>
                    
                    <td>
                      <a target="_blank" :href="'/products/edit/'+row.order_item.product.id" class="text-dark">{{row.order_item.product.title
                        }}</a>
                    </td>
                    <td>
                      <b-badge variant="light" class="text-dark">{{row.order_item ? $root.full_name(row.order_item.product.presenter.firstname,row.order_item.product.presenter.lastname) : ""
                        }}</b-badge>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </section>
            <a-row class="pagination">
              <a-pagination
                  :total="total"
                  :item-render="$root.itemRender"
                  @change="getData(currentPage)"
                  v-model="currentPage"
              />
            </a-row>
          </div>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>

export default {
  data() {
    return {
      data: [],
      currentPage: 1,
      total: 0,
      isHidden: false,
      search: {
        start: "",
        end: "",
      },
    };
  },
  methods: {
    async getData() {
      let _this = this;
      this.$store.state.loading = true;
      let url = `/financial/revenue?page=${this.currentPage}&&start=${this.search.start}&&end=${this.search.end}`;
      await axios
          .get(url)
          .then(function (response) {
            _this.data = response.data.data;
            _this.$store.state.loading = false;
            _this.total = response.data.total;
            _this.currentPage = response.data.current_page;
          })
          .catch(function (err) {
            _this.$root.handleAxiosError(err);
          });
    }
    
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scope>
.pagination {
  display: flex;
  justify-content: center;
  margin: 15px;
}
</style>
